import React, { useRef } from 'react';
import SafeIcon from './SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCamera, FiUploadCloud } = FiIcons;

const ImageUpload = ({ value, onChange, label, className = "w-24 h-24" }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        alert("File is too large. Please keep it under 2MB.");
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex flex-col items-center gap-2">
      {label && <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{label}</label>}
      <div 
        onClick={() => fileInputRef.current?.click()}
        className={`relative group cursor-pointer overflow-hidden rounded-[2rem] border-4 border-white shadow-xl bg-slate-100 ${className}`}
      >
        {value ? (
          <img src={value} alt="Upload" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-300">
            <SafeIcon icon={FiUploadCloud} className="text-2xl" />
          </div>
        )}
        <div className="absolute inset-0 bg-blue-600/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <SafeIcon icon={FiCamera} className="text-white text-xl" />
        </div>
      </div>
      <input 
        type="file" 
        ref={fileInputRef} 
        onChange={handleFileChange} 
        accept="image/jpeg,image/png" 
        className="hidden" 
      />
      <p className="text-[8px] text-slate-400 font-bold uppercase tracking-tighter">JPG or PNG (Max 2MB)</p>
    </div>
  );
};

export default ImageUpload;